import React, { useCallback, useEffect } from 'react';
import { compose, pick } from 'js/utils/ramda.util';
import { Table, TABLE_VIEW } from 'js/components/common/Table';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { withDynamicReducer, useDynamicReducerSelector } from './store';

import * as style from './FreeSpinsBalance.scss';

export const FreeSpinsBalanceBare = () => {
    const tableData = hooks.useTableData();
    const translate = useComponentTranslations();
    const fetchFreeSpins = hooks.useFetchFreeSpins();
    const emptyTitle = translate('noBonuses');
    const fetchFreeSpinDetails = hooks.useFetchFreeSpinDetails();
    const { isLoading, error } = useDynamicReducerSelector(pick(['isLoading', 'error']));
    const onAccordionExpand = useCallback((id) => {
        fetchFreeSpinDetails(id);
    }, [fetchFreeSpinDetails]);

    useEffect(() => {
        fetchFreeSpins();
    }, [fetchFreeSpins]);

    return (
         <Table
            error={error}
            classNames={style}
            isLoading={isLoading}
            tableData={tableData}
            emptyTitle={emptyTitle}
            showTableBody={Boolean(!error)}
            tableRowView={TABLE_VIEW.ACCORDION}
            onAccordionExpand={onAccordionExpand}
         />
    );
};

export const FreeSpinsBalance = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.freespin.'
    }),
    withDynamicReducer()
)(FreeSpinsBalanceBare);

componentService.registerWebContentComponents({ AllFreeSpins: FreeSpinsBalance });
